import React, { useEffect, useState, useRef } from "react";
import Styles from "./Navbar.module.scss";
import styled from "./Modal.module.scss";
import { BellOutlined, SyncOutlined } from "@ant-design/icons";
import sound from "./alert/BEEPMULT.mp3";
import { useNavigate } from "react-router-dom";
import User from "./User/User.component";
import { logOut } from "../../redux/user/actions/user.actions";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmationModal } from "../Modal/ConfirmationModal";
import dateFormat from "../../helper/DateFormatter";
import { BsClockHistory } from "react-icons/bs";
import Notification from "./notification/Notification";
import {
  notificationsList,
  viewNotification,
} from "../../redux/orders/actions/orders.actions";

const Navbar = ({ title, url }) => {
  const [openModal, setopenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [canPlaySound, setCanPlaySound] = useState(false);
  const audioRef = useRef(null);
  const lastNotifiedIdRef = useRef(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();

    const { notifications } = useSelector((state) => state.orderReducer);
    const totalNot = notifications?.length;

     // Prepare audio element once
  useEffect(() => {
    const audio = new Audio(sound);
    audio.preload = "auto";
    audioRef.current = audio;
  }, []);


   // Enable audio only after a user interaction (browser autoplay policy)
  useEffect(() => {
    const enableSound = () => {
      setCanPlaySound(true);
      // Try to unlock audio on user gesture without making an audible sound
      try {
        if (audioRef.current) {
          audioRef.current.muted = true;
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch(() => {});
          // Small timeout then pause and unmute to avoid audible beep
          setTimeout(() => {
            try {
              audioRef.current.pause();
              audioRef.current.muted = false;
            } catch {}
          }, 50);
        }
      } catch {}

      // Ask for notification permission to allow system notifications in background
      if (typeof Notification !== "undefined" && Notification.permission === "default") {
        try {
          Notification.requestPermission().catch(() => {});
        } catch {}
      }
      window.removeEventListener("click", enableSound);
      window.removeEventListener("keydown", enableSound);
      window.removeEventListener("touchstart", enableSound);
    };
    window.addEventListener("click", enableSound, { once: true });
    window.addEventListener("keydown", enableSound, { once: true });
    window.addEventListener("touchstart", enableSound, { once: true });
    return () => {
      window.removeEventListener("click", enableSound);
      window.removeEventListener("keydown", enableSound);
      window.removeEventListener("touchstart", enableSound);
    };
  }, []);

  // Polling: set up once, no dependency on notifications to avoid loops
  useEffect(() => {
    setLoading(true);
    const fetchOrders = () => {
      dispatch(notificationsList());
    };
    fetchOrders();
    const myInterval = setInterval(fetchOrders, 15000);
    setLoading(false);
    return () => {
      clearInterval(myInterval);
    };
  }, [dispatch]);

  // Play sound and show system notification when notifications change
  useEffect(() => {
    if (!canPlaySound) return;
    if (!notifications || notifications.length === 0) return;

    // Determine if there are new notifications by comparing max id
    const currentMaxId = notifications.reduce((max, n) =>
      n && typeof n.id === "number" && n.id > max ? n.id : max,
      lastNotifiedIdRef.current ?? -Infinity
    );

    const hasNew =
      lastNotifiedIdRef.current == null
        ? notifications.length > 0
        : currentMaxId > (lastNotifiedIdRef.current ?? -Infinity);

    if (!hasNew) return;

    lastNotifiedIdRef.current = Math.max(
      currentMaxId,
      lastNotifiedIdRef.current ?? -Infinity
    );

    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }

    if (
      typeof Notification !== "undefined" &&
      Notification.permission === "granted" &&
      document.hidden
    ) {
      try {
        const latest = (notifications ? [...notifications] : [])
          .sort((a, b) => (a.id > b.id ? -1 : 1))[0];
        new Notification("New notification", {
          body: latest?.ordertype ? String(latest.ordertype) : "You have a new update.",
        });
      } catch {}
    }
  }, [notifications, canPlaySound]);

  const viewOrder = (id, key) => {
    dispatch(viewNotification(id, key));
    setopenModal(false);

    key === "No Acceptance" ? navigate("/ongoing") : navigate("/failed-bids");

    // channel === "Dispatch"
    //   ? navigate("/ongoing-orders")
    //   : channel === "quotation"
    //   ? navigate("/see-quotation")
    //   : channel === "Bids"
    //   ? navigate("/bid")
    //   : channel === "OneHP"
    //   ? navigate("/ongoing-orders")
    //   : navigate("/new-orders");
    // navigate("/failed-bids");
  };


  let userDetails;
  if (localStorage.getItem("userDetails")) {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }

  useEffect(() => {
    if (!userDetails) {
      navigate(`/login`);
    }
  }, []);

  

  return (
    <div className={Styles.navbarCont}>
      <div className={Styles.navbarContInner}>
        <div className={Styles.dashboardName}>
          <p className={`${Styles.dashboardName} d-none d-md-block`}>
            {title || ""}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className={Styles.navContentLeft}
            onClick={() => setopenModal(true)}
          >
            <div className={Styles.navContentLeftIcons}>
              {notifications?.length > 0 ? (
                <BellOutlined spin style={{ color: "white", fontSize: 28 }} />
              ) : (
                <BellOutlined style={{ color: "white", fontSize: 28 }} />
              )}
              <div className={Styles.count}>{totalNot || 0}</div>
            </div>
          </div>
        <div className={Styles.dashboardName}>
          <User
            username={userDetails?.data?.name}
            onClick={() => dispatch(logOut())}
          />
        </div>

        </div>
      </div>

      {/* DIALOG MODAL */}
       <ConfirmationModal
  open={openModal}
  handleClose={() => setopenModal(false)}
  bgcolor="background.paper"
  width="80vw"
  height="70vh"
  closemodal={() => setopenModal(false)}
  instruction={
    notifications?.length > 0 ? (
      <>
        <div className={styled.title}>NOTIFICATION(S)</div>
        {loading && <SyncOutlined spin />}

        {/* 👇 Scroll container */}
        <div className={styled.scrollContainer}>
          {[...notifications]
            .sort((a, b) => (a.id > b.id ? -1 : 1))
            .map((n) => (
              <div className={styled.container} key={n?.id}>
                <div className={styled.icon}>
                  <BellOutlined style={{ color: "brown", fontSize: 28 }} />
                </div>

                <p className={styled.text}>{n?.message}</p>

                <div
                  className={styled.btn}
                  onClick={() => viewOrder(n?.id, n?.key)}
                >
                  View
                </div>
              </div>
            ))}
        </div>
      </>
    ) : (
      <p className={styled.notification}>
        You don't have new notifications
      </p>
    )
  }
/>

    </div>
  );
};

export default Navbar;
